import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<{ id: number; message: string; type: string }[]>([])
  let counter = 0

  function show(message: string, type = 'success', duration = 3000) {
    const id = ++counter
    toasts.value.push({ id, message, type })

    setTimeout(() => {
      toasts.value = toasts.value.filter(t => t.id !== id)
    }, duration)
  }

  return { toasts, show }
})